import { Box, Skeleton, Stack } from "@mui/material";
import { BankImage } from "Components/Shared/BankImage";

export const MerchantPaymentComponentSkeleton = () => (
  <Stack gap={4}>
    <Box display="flex" width="100%" justifyContent="space-between" mt={2}>
      <Skeleton width={200} height={40} variant="rounded" />
      <BankImage isLoading isRounded />
    </Box>
    <Skeleton width="100%" height={60} variant="rounded" />
  </Stack>
);
